import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react'
import useAuth from '../hooks/useAuth';

const signupPage1 = process.env.REACT_APP_BILLING_SUBSCRIPTION_SIGNUP_PAGE1;
const signupPage2 = process.env.REACT_APP_BILLING_SUBSCRIPTION_SIGNUP_PAGE2;
const signupPage3 = process.env.REACT_APP_BILLING_SUBSCRIPTION_SIGNUP_PAGE3;


function Subscribe() {
    const { auth } = useAuth();
    const constructSignupLink = (link) => {
        return link + '?reference=' + auth.account.Id + '&first_name=' + encodeURIComponent(auth.account.FirstName) + '&last_name=' + encodeURIComponent(auth.account.LastName) + '&email=' + encodeURIComponent(auth.account.EmailAddress);
    };

    return (
        <section>
            <div className="container">
                <div className="justify-content-md-center">
                    <h4 className="display-6 mb-4 text-center">Choose Your Subscription Plan</h4>
                    <hr className="w-50 mx-auto mb-5 mb-xl-9 border-dark-subtle" />
                </div>
            </div>

            <div className="container">
                <div className="row gy-5 gy-lg-0 gx-xl-5">
                    <div className="col-12 col-lg-4">
                        <div className="card border-0 border-bottom border-primary shadow-sm">
                            <div className="card-body p-4 p-xxl-5">
                                <h2 className="h4 mb-2">Single Event</h2>
                                <h4 className="display-3 fw-bold text-primary mb-0">$290</h4>
                                <p className="text-secondary mb-4">USD / Year</p>
                                <ul className="list-group list-group-flush mb-4">
                                    <li className="list-group-item">
                                        <FontAwesomeIcon icon={faCheck} fixedWidth className='text-success' /> <span><strong>14</strong> Days Free Trial</span>
                                    </li>
                                    <li className="list-group-item">
                                        <FontAwesomeIcon icon={faCheck} fixedWidth className='text-success' /> <span><strong>1</strong> Campaign</span>
                                    </li>
                                    <li className="list-group-item">
                                        <FontAwesomeIcon icon={faTimes} fixedWidth className='text-danger' /> <span>Gallery</span>
                                    </li>
                                    <li className="list-group-item">
                                        <FontAwesomeIcon icon={faCheck} fixedWidth className='text-success' /> <span>Access to Hosted Videos</span>
                                    </li>
                                    <li className="list-group-item">
                                        <FontAwesomeIcon icon={faCheck} fixedWidth className='text-success' /> <span>Access to Backend of VideoBoost</span>
                                    </li>
                                </ul>
                                <div className='text-center'>
                                    <a href={constructSignupLink(signupPage1)} className="btn bsb-btn-xl btn-primary rounded-pill">Choose Plan</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-4">
                        <div className="card border-0 border-bottom border-primary shadow-lg pt-md-4 pb-md-4 bsb-pricing-popular">
                            <div className="card-body p-4 p-xxl-5">
                                <h2 className="h4 mb-2">Unlimited Events [Monthly]</h2>
                                <h4 className="display-3 fw-bold text-primary mb-0">$95</h4>
                                <p className="text-secondary mb-4">USD / Month</p>
                                <ul className="list-group list-group-flush mb-4">
                                    <li className="list-group-item">
                                        <FontAwesomeIcon icon={faCheck} fixedWidth className='text-success' /> <span><strong>14</strong> Days Free Trial</span>
                                    </li>
                                    <li className="list-group-item">
                                        <FontAwesomeIcon icon={faCheck} fixedWidth className='text-success' /> <span><strong>Unlimited</strong> Campaigns</span>
                                    </li>
                                    <li className="list-group-item">
                                        <FontAwesomeIcon icon={faCheck} fixedWidth className='text-success' /> <span><strong>$49</strong> Per Gallery</span>
                                    </li>
                                    <li className="list-group-item">
                                        <FontAwesomeIcon icon={faCheck} fixedWidth className='text-success' /> <span>Access to Hosted Videos</span>
                                    </li>
                                    <li className="list-group-item">
                                        <FontAwesomeIcon icon={faCheck} fixedWidth className='text-success' /> <span>Access to Backend of VideoBoost</span>
                                    </li>
                                </ul>
                                <div className='text-center'>
                                    <a href={constructSignupLink(signupPage2)} className="btn bsb-btn-xl btn-primary rounded-pill">Choose Plan</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-4">
                        <div className="card border-0 border-bottom border-primary shadow-sm">
                            <div className="card-body p-4 p-xxl-5">
                                <h2 className="h4 mb-2">Unlimited Events [Annually]</h2>
                                <h4 className="display-3 fw-bold text-primary mb-0">$990</h4>
                                <p className="text-secondary mb-4">USD / Year</p>
                                <ul className="list-group list-group-flush mb-4">
                                    <li className="list-group-item">
                                        <FontAwesomeIcon icon={faCheck} fixedWidth className='text-success' /> <span><strong>14</strong> Days Free Trial</span>
                                    </li>
                                    <li className="list-group-item">
                                        <FontAwesomeIcon icon={faCheck} fixedWidth className='text-success' /> <span><strong>Unlimited</strong> Campaigns</span>
                                    </li>
                                    <li className="list-group-item">
                                        <FontAwesomeIcon icon={faCheck} fixedWidth className='text-success' /> <span><strong>$49</strong> per Gallery</span>
                                    </li>
                                    <li className="list-group-item">
                                        <FontAwesomeIcon icon={faCheck} fixedWidth className='text-success' /> <span>Access to Hosted Videos</span>
                                    </li>
                                    <li className="list-group-item">
                                        <FontAwesomeIcon icon={faCheck} fixedWidth className='text-success' /> <span>Access to Backend of VideoBoost</span>
                                    </li>
                                </ul>
                                <div className='text-center'>
                                    <a href={constructSignupLink(signupPage3)} className="btn bsb-btn-xl btn-primary rounded-pill">Choose Plan</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Subscribe
